import { DataGridColSettings } from '@/components/DataGrid/utils';

export const towingCompanies = [
  'Not assigned',
  'FastTow Inc.',
  'CityTow Services',
  'QuickHaul Towing',
  'Metro Tow & Recovery',
  'Downtown Wrecker',
  'Tow Solutions',
  'Express Recovery LLC',
  'Metro Towing Service',
  'Quick Tow Inc',
  'Tow Pro Solutions',
  'Tow Masters LLC',
  'City Towing Agency',
  'Rapid Recovery Co',
  'Elite Tow Services',
] as const;

export const TowingManagementTableColumns: DataGridColSettings[] = [
  {
    field: 'position',
    headerName: 'Position',
    width: 150,
    visible: true,
  },
  {
    field: 'company',
    headerName: 'Company',
    width: 200,
    visible: true,
  },
  {
    field: 'contact',
    headerName: 'Contact',
    width: 200,
    visible: true,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone number',
    width: 180,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    visible: true,
  },
  {
    field: 'lastUsed',
    headerName: 'Last Used',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

export const towingManagementTableData = [
  {
    position: 1,
    company: 'FastTow Inc.',
    contact: 'John Doe',
    phoneNumber: '(555) 123-4567',
    status: 'Active',
    lastUsed: '2025-07-21',
  },
  {
    position: 2,
    company: 'CityTow Services',
    contact: 'Jane Smith',
    phoneNumber: '(555) 987-6543',
    status: 'Inactive',
    lastUsed: '2025-06-15',
  },
  {
    position: 3,
    company: 'QuickHaul Towing',
    contact: 'Carlos Rivera',
    phoneNumber: '(555) 222-3333',
    status: 'Active',
    lastUsed: '2025-07-18',
  },
  {
    position: 4,
    company: 'Metro Tow & Recovery',
    contact: 'Samantha Lee',
    phoneNumber: '(555) 444-7777',
    status: 'Pending',
    lastUsed: '2025-05-10',
  },
  {
    position: 5,
    company: 'Downtown Wrecker',
    contact: 'Liam Patel',
    phoneNumber: '(555) 888-1111',
    status: 'Active',
    lastUsed: '2025-07-20',
  },
];

export const TowingRecordsTableColumns: DataGridColSettings[] = [
  {
    field: 'incident',
    headerName: 'Incident #',
    width: 150,
    visible: true,
  },
  {
    field: 'date',
    headerName: 'Date and time',
    width: 200,
    visible: true,
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 180,
    visible: true,
  },
  {
    field: 'vehicle',
    headerName: 'Vehicle',
    width: 160,
    visible: true,
  },
  {
    field: 'initiator',
    headerName: 'Initiator',
    width: 160,
    visible: true,
  },
  {
    field: 'company',
    headerName: 'Company',
    width: 180,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

export const towingRecordDummyData = [
  {
    id: '1',
    incident: 'TOW-2025-001',
    date: '2025-07-16T12:32:00Z',
    type: 'Police',
    licensePlate: 'ABC123',
    make: 'Honda',
    model: 'Civic',
    year: '2018',
    initiator: 'Officer Jennifer Adams',
    badgeNumber: '1247',
    company: 'Not assigned',
    status: 'Released',
    vin: '1HGBH41JXMN109186',
    color: 'Blue',
    towFromLocation: '5th Ave & Pine St',
    destination: 'North Lot',
    reason: 'Accident - left in unsafe condition',
    estimatedCost: '250',
    actualCost: '240',
    additionalNotes: 'Released at scene after inspection',
  },
  {
    id: '2',
    incident: 'TOW-2025-002',
    date: '2025-07-12T11:15:00Z',
    type: 'Private',
    licensePlate: 'XYZ789',
    make: 'Toyota',
    model: 'Corolla',
    year: '2018',
    initiator: 'Robert Smith',
    badgeNumber: '',
    company: 'Express Recovery LLC',
    status: 'In progress',
    vin: 'JTDEPRAE5LJ015347',
    color: 'Black',
    towFromLocation: 'Union Mall Lot C',
    destination: 'City Garage West',
    reason: 'Stalled vehicle, blocking drive lane',
    estimatedCost: '180',
    actualCost: '',
    additionalNotes: 'Driver notified; no injuries reported',
  },
  {
    id: '3',
    incident: 'TOW-2025-003',
    date: '2025-07-09T09:28:00Z',
    type: 'Police',
    licensePlate: 'XYZ789',
    make: 'Toyota',
    model: 'Corolla',
    year: '2018',
    initiator: 'Officer Mark Johnson',
    badgeNumber: '0892',
    company: 'Metro Towing Service',
    status: 'Completed',
    vin: '2T1BURHE9JC050133',
    color: 'Silver',
    towFromLocation: 'Downtown Parking Zone B',
    destination: 'Impound Lot #3',
    reason: 'Double parked in emergency zone',
    estimatedCost: '210',
    actualCost: '210',
    additionalNotes: '',
  },
  {
    id: '4',
    incident: 'TOW-2025-004',
    date: '2025-07-05T14:45:00Z',
    type: 'Private',
    licensePlate: 'LMN456',
    make: 'Ford',
    model: 'Focus',
    year: '2019',
    initiator: 'Sarah Lee',
    badgeNumber: '',
    company: 'Quick Tow Inc',
    status: 'In progress',
    vin: '1FADP3K23KL251678',
    color: 'White',
    towFromLocation: 'Garage exit ramp, Lot D',
    destination: 'Private Shop',
    reason: 'Battery failure, unable to start',
    estimatedCost: '160',
    actualCost: '',
    additionalNotes: 'Tow requested by owner',
  },
  {
    id: '5',
    incident: 'TOW-2025-005',
    date: '2025-07-03T08:22:00Z',
    type: 'Police',
    licensePlate: 'DEF234',
    make: 'Chevrolet',
    model: 'Malibu',
    year: '2020',
    initiator: 'Officer Alex Turner',
    badgeNumber: '0234',
    company: 'Tow Pro Solutions',
    status: 'Released',
    vin: '1G1ZD5ST7LF072345',
    color: 'Gray',
    towFromLocation: 'Main St bus stop area',
    destination: 'West Impound Yard',
    reason: 'Obstructing traffic due to collision',
    estimatedCost: '300',
    actualCost: '300',
    additionalNotes: 'Released after photo evidence taken',
  },
  {
    id: '6',
    incident: 'TOW-2025-006',
    date: '2025-06-30T16:10:00Z',
    type: 'Private',
    licensePlate: 'GHI567',
    make: 'Nissan',
    model: 'Altima',
    year: '2021',
    initiator: 'Emily Davis',
    badgeNumber: '',
    company: 'Tow Masters LLC',
    status: 'Completed',
    vin: '1N4AL3AP4JC123456',
    color: 'Red',
    towFromLocation: 'Uptown Blvd near Park Center',
    destination: 'Repair Shop North',
    reason: 'Flat tire and engine failure',
    estimatedCost: '230',
    actualCost: '230',
    additionalNotes: '',
  },
  {
    id: '7',
    incident: 'TOW-2025-007',
    date: '2025-06-28T13:30:00Z',
    type: 'Police',
    licensePlate: 'JKL890',
    make: 'Subaru',
    model: 'Impreza',
    year: '2022',
    initiator: 'Officer Brian Wilson',
    badgeNumber: '0785',
    company: 'City Towing Agency',
    status: 'In progress',
    vin: 'JF1GPAA63CH289347',
    color: 'Green',
    towFromLocation: 'Main Library rear alley',
    destination: 'City Lot South',
    reason: 'Blocking emergency access',
    estimatedCost: '260',
    actualCost: '',
    additionalNotes: '',
  },
  {
    id: '8',
    incident: 'TOW-2025-008',
    date: '2025-06-25T17:55:00Z',
    type: 'Private',
    licensePlate: 'MNO123',
    make: 'Kia',
    model: 'Soul',
    year: '2017',
    initiator: 'Lucas Brown',
    badgeNumber: '',
    company: 'Rapid Recovery Co',
    status: 'Not assigned',
    vin: 'KNDJP3A56H7159372',
    color: 'Yellow',
    towFromLocation: 'Airport parking lot D',
    destination: 'Service Garage A',
    reason: 'Mechanical failure',
    estimatedCost: '190',
    actualCost: '',
    additionalNotes: 'Tow driver dispatched but delayed',
  },
  {
    id: '9',
    incident: 'TOW-2025-009',
    date: '2025-06-23T10:05:00Z',
    type: 'Police',
    licensePlate: 'PQR456',
    make: 'Hyundai',
    model: 'Elantra',
    year: '2021',
    initiator: 'Officer Jessica White',
    badgeNumber: '0456',
    company: 'Metro Towing Service',
    status: 'Completed',
    vin: '5NPD84LF5KH455678',
    color: 'White',
    towFromLocation: 'School zone, Oakridge Dr',
    destination: 'Impound Lot Central',
    reason: 'Vehicle left unattended in fire lane',
    estimatedCost: '220',
    actualCost: '220',
    additionalNotes: '',
  },
  {
    id: '10',
    incident: 'TOW-2025-010',
    date: '2025-06-20T15:40:00Z',
    type: 'Private',
    licensePlate: 'STU345',
    make: 'Volkswagen',
    model: 'Jetta',
    year: '2020',
    initiator: 'Michael Green',
    badgeNumber: '',
    company: 'Elite Tow Services',
    status: 'In progress',
    vin: '3VW2B7AJ7EM428987',
    color: 'Black',
    towFromLocation: 'Warehouse complex zone 2',
    destination: 'Downtown Garage',
    reason: 'Owner requested voluntary tow',
    estimatedCost: '175',
    actualCost: '',
    additionalNotes: '',
  },
];

export type TowRecordFormValues = {
  dateTime: string;
  towType: string;
  officerName: string;
  badgeNumber: string;
  licensePlate: string;
  vin: string;
  year: string;
  make: string;
  model: string;
  color: string;
  towFromLocation: string;
  destination: string;
  towingCompany: string;
  status: string;
  reason: string;
  estimatedCost: string;
  actualCost: string;
  additionalNotes: string;
};

export const towingCompaniesDummyData = [
  {
    id: 1,
    position: 1,
    company: 'Tow Solutions · TOW-2025-001',
    contact: 'John Rodriguez',
    phoneNumber: '(555) 123-4567',
    status: 'Active',
    lastUsed: '2025-07-16',
    serviceArea: 'Metropolitan City, Downtown District, Industrial Zone',
    address: '1234 Industrial Blvd, Metropolitan City, ST 12345',
  },
  {
    id: 2,
    position: 2,
    company: 'Express Recovery LLC · TOW-2025-002',
    contact: 'Mike Thompson',
    phoneNumber: '(555) 234-5678',
    status: 'Active',
    lastUsed: 'Never',
    serviceArea: 'Highway corridors, Suburban areas, Commercial districts',
    address: '5678 Highway 101, Metropolitan City, ST 12345',
  },
  {
    id: 3,
    position: 3,
    company: 'Metro Towing Service · TOW-2025-003',
    contact: 'Sarah Johnson',
    phoneNumber: '(555) 345-6789',
    status: 'Inactive',
    lastUsed: '2024-05-12',
    serviceArea: 'City-wide coverage, Specialized heavy vehicle recovery',
    address: '9101 Service Road, Metropolitan City, ST 12345',
  },
  {
    id: 4,
    position: 4,
    company: 'Quick Tow Inc · TOW-2025-004',
    contact: 'David Lee',
    phoneNumber: '(555) 456-7890',
    status: 'Active',
    lastUsed: '2026-01-01',
    serviceArea: 'Commercial zones, Fleet services',
    address: '2468 Main Street, Metropolitan City, ST 12345',
  },
  {
    id: 5,
    position: 5,
    company: 'Tow Pro Solutions · TOW-2025-005',
    contact: 'Emily Clarke',
    phoneNumber: '(555) 567-8901',
    status: 'Active',
    lastUsed: '2025-11-15',
    serviceArea: 'Residential areas, Shopping centers, Local streets',
    address: '1357 Commerce Drive, Metropolitan City, ST 12345',
  },
  {
    id: 6,
    position: 6,
    company: 'Tow Masters LLC · TOW-2025-006',
    contact: 'Chris Martinez',
    phoneNumber: '(555) 678-9012',
    status: 'Inactive',
    lastUsed: '2023-09-20',
    serviceArea: 'Metropolitan City, Downtown District, Industrial Zone',
    address: '5678 Highway 101, Metropolitan City, ST 12345',
  },
  {
    id: 7,
    position: 7,
    company: 'City Towing Agency · TOW-2025-007',
    contact: 'Jessica Smith',
    phoneNumber: '(555) 789-0123',
    status: 'Active',
    lastUsed: '2026-08-30',
    serviceArea: 'Highway corridors, Suburban areas, Commercial districts',
  },
  {
    id: 8,
    position: 8,
    company: 'Rapid Recovery Co · TOW-2025-008',
    contact: 'Ryan Baker',
    phoneNumber: '(555) 890-1234',
    status: 'Active',
    lastUsed: 'Never',
    serviceArea: 'City-wide coverage, Specialized heavy vehicle recovery',
    address: '9101 Service Road, Metropolitan City, ST 12345',
  },
  {
    id: 9,
    position: 9,
    company: 'Metro Towing Service · TOW-2025-009',
    contact: 'Laura Wilson',
    phoneNumber: '(555) 901-2345',
    status: 'Active',
    lastUsed: '2024-04-05',
    serviceArea: 'Commercial zones, Fleet services',
    address: '2468 Main Street, Metropolitan City, ST 12345',
  },
  {
    id: 10,
    position: 10,
    company: 'Elite Tow Services · TOW-2025-010',
    contact: 'Michael Brown',
    phoneNumber: '(555) 012-3456',
    status: 'Inactive',
    lastUsed: '2023-06-22',
    serviceArea: 'Residential areas, Shopping centers, Local streets',
    address: '1357 Commerce Drive, Metropolitan City, ST 12345',
  },
];
